import { useEffect } from 'react';
import styled from 'styled-components';

import type { InteractionTrackingEvent } from '@xing-com/crate-communication-tracking';
import { useTracking } from '@xing-com/crate-communication-tracking';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { SEARCH_ALERTS_MODAL_TYPES } from '@xing-com/crate-jobs-constants';
import { useBreakpoints, useSearchAlert } from '@xing-com/crate-jobs-hooks';
import type { PropTrackActionData } from '@xing-com/crate-jobs-hooks';
import { mediaConfined } from '@xing-com/layout-tokens';
import { PopUpWindow } from '@xing-com/pop-up-window';

import { LIContent, LOContent } from './content';

export const PopUp = styled(PopUpWindow)`
  && > div {
    @media ${mediaConfined} {
      width: 600px;
      min-height: 320px;
    }
  }
`;

export const DesktopModal: React.FC = () => {
  const {
    searchQueryId,
    activeParam,
    isQuerySaved,
    isModalActive,
    onClose,
    onCreate,
  } = useSearchAlert();
  const { isMediaSmallOrTiny } = useBreakpoints();
  const { isLoggedIn } = useLoginState();
  const { track } =
    useTracking<InteractionTrackingEvent<PropTrackActionData>>();

  useEffect(() => {
    if (activeParam) {
      track({
        type: 'interaction',
        event: 'PropTrackAction',
        PropTrackAction: 'jobs_search_alert_create_open',
        PropActionOrigin:
          activeParam === SEARCH_ALERTS_MODAL_TYPES.REPEAT
            ? 'jobs_search_recent_searches'
            : 'jobs_bell_link',
      });
    }
  }, [activeParam, track]);

  const isActive = isModalActive([
    SEARCH_ALERTS_MODAL_TYPES.CREATE,
    SEARCH_ALERTS_MODAL_TYPES.REPEAT,
  ]);

  return (
    <PopUp
      isShown={isActive && !isMediaSmallOrTiny}
      hide={onClose}
      onDimmerClick={onClose}
    >
      {isLoggedIn ? (
        <LIContent
          disabled={!searchQueryId}
          isQuerySaved={isQuerySaved}
          onCreate={onCreate}
          onClose={onClose}
        />
      ) : (
        <LOContent type={activeParam} onClose={onClose} />
      )}
    </PopUp>
  );
};
